import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Customized to your skin',
    desc: 'We select exact wavelengths for your specific concerns.'
  }, {
    num: '2',
    title: 'The session (30–45 min)',
    desc: 'Light targets damage while activating renewal.'
  }, {
    num: '3',
    title: 'The reveal (1–2 weeks)',
    desc: 'Pigmentation rises and flakes away. Even, luminous skin underneath.'
  }];
  return <section className="py-20 md:py-32 bg-brand-bg" data-id="element-146">
      <div className="container px-4 md:px-6" data-id="element-147">
        <div className="text-center mb-16 md:mb-24" data-id="element-148">
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-brand-text" data-id="element-149">
            How It Works
          </h2>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-150">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-[28px] left-[10%] right-[10%] h-[1px] bg-brand-divider z-0" data-id="element-151"></div>

          <div className="flex flex-col md:flex-row gap-12 md:gap-6 relative z-10" data-id="element-152">
            {steps.map((step, index) => <div key={index} className="flex-1 flex flex-col items-center text-center group" data-id="element-153">
                <div className="w-14 h-14 rounded-full bg-brand-bg border border-brand-gold flex items-center justify-center text-brand-gold font-playfair text-xl mb-6 transition-colors duration-300 group-hover:bg-brand-gold group-hover:text-white" data-id="element-154">
                  {step.num}
                </div>
                <h3 className="font-playfair text-xl md:text-2xl text-brand-text mb-3" data-id="element-155">
                  {step.title}
                </h3>
                <p className="font-sans text-brand-text/70 leading-relaxed max-w-xs" data-id="element-156">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}